import { DataManager } from '@syncfusion/ej2-data';
import { FinanceClientPriceModelService } from './finance-client-price-model.service';
import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EditSettingsModel, GridComponent, GridModule, SaveEventArgs, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { Subscription } from 'rxjs';
import { FinanceClientPriceModelDTO, FinancePriceModelDataDTO } from 'src/app/base/models/models.swagger.generated';
import { SfAction, SfRequestTypes } from 'src/app/base/models/syncfusion-data';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { FormsModule } from '@angular/forms';
import { ModalHelperService } from 'src/app/base/shared/modal-helper';

@Component({
  selector: 'app-price-model-edit',
  templateUrl: './price-model-edit.component.html',
  styleUrls: ['./price-model-edit.component.scss'],
  standalone: true,
  imports: [
    DropDownListModule,
    DialogModule,
    TranslateModule,
    GridModule,
    DatePipe,
    FormsModule
  ]
})

export class PriceModelEditComponent implements OnInit, OnDestroy {

  @ViewChild('priceModelDialog') public priceModelDialog: DialogComponent;
  @ViewChild('grid') public grid: GridComponent;

  public priceModels: FinanceClientPriceModelDTO[] = [];

  public priceModelMasterData: FinancePriceModelDataDTO;
  private clientId: number;
  private _subscriptions: Subscription = new Subscription();

  public editSettings: EditSettingsModel = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal', showDeleteConfirmDialog: true };
  public toolbar: ToolbarItems[] = ['Add', 'Edit', 'Delete', 'Update', 'Cancel'];
  public percentRules: object = { min: 0, max: 100, required: true };
  public percentOrNullRules: object = { min: 0, max: 100, required: false };
  public priceRules: object = { min: 0, max: 10000, required: true };
  public numberRules: object = { min: 0, max: 100000, required: true };
  public parkingSpacePriceModelEdit?: Object;
  public parkerPriceModelEdit?: Object;
  public dropDownFields: Object = { text: 'modelName', value: 'modelName' };
  public priceModel: FinanceClientPriceModelDTO | any;

  constructor(
    private service: FinanceClientPriceModelService,
    private translateService: TranslateService,
    private modalService: ModalHelperService
  ) { }

  ngOnInit() {
    if (this.priceModelMasterData === undefined) {
      this._subscriptions.add(
        this._subscriptions.add(this.service.getPriceModelMasterData().subscribe(
          (priceModelMasterData) => {
            this.priceModelMasterData = priceModelMasterData;
            this.parkerPriceModelEdit = {
              params: {
                dataSource: new DataManager(this.priceModelMasterData.parkerPriceModels),
                fields: { text: 'modelName', value: 'modelName' },
                actionComplete: () => false,
                popupWidth: '250px',
              }
            };
            this.parkingSpacePriceModelEdit = {
              params: {
                dataSource: new DataManager(this.priceModelMasterData.parkingSpacePriceModels),
                fields: { text: 'modelName', value: 'modelName' },
                actionComplete: () => false,
                popupWidth: '250px',
              }
            };
          }
        )
        )
      );
    }
  }

  public openDialog(clientId: number) {
    this.clientId = clientId;
    this._subscriptions.add(
      this.service.getPriceModel(clientId).subscribe(
        (priceModels) => {
          this.priceModels = priceModels;
        }
      )
    );
    this.priceModelDialog.show();
  }

  public closePriceModelDialog() {
    // check if any changes were made, if yes show confirm dialog
    if (this.grid.isEdit) {
      this.modalService.confirm('i18n.errors.discard-dialog.title', 'i18n.errors.discard-dialog.question', () => {
        this.priceModelDialog.hide();
      });
    }
    else {
      this.priceModelDialog.hide();
    }
  }

  public formatBoolean(value: boolean): string {
    if (value === true) {
      return this.translateService.instant('i18n.shared.yes');
    } else {
      return this.translateService.instant('i18n.shared.no');
    }
  }

  public actionBegin(args: SaveEventArgs) {
    if (args.requestType === SfRequestTypes.BeginEdit || args.requestType === SfRequestTypes.Add) {
      this.priceModel = Object.assign({}, args.rowData);
    }
    if (args.requestType === SfRequestTypes.Save) {
      (args.data as FinanceClientPriceModelDTO).parkerPriceModelName = this.priceModel.parkerPriceModelName;
      (args.data as FinanceClientPriceModelDTO).parkingSpacePriceModelName = this.priceModel.parkingSpacePriceModelName;
    }
  }

  public actionComplete(args: any) {
    if (args.requestType === SfRequestTypes.Save) {
      if (args.action === SfAction.Add) {
        this._subscriptions.add(this.service.createPriceModel(this.clientId, args.data).subscribe(() => {
          this.refreshGrid();
        }));

      }
      else if (args.action === SfAction.Edit) {
        this.service.updatePriceModel(args.data).subscribe(() => {
          this.refreshGrid();
        });
      }
    }
    else if (args.requestType === SfRequestTypes.Delete) {
      this.service.deletePriceModel(args.data[0].id).subscribe(() => {
        this.refreshGrid();
      });
    }
  }

  private refreshGrid() {
    this._subscriptions.add(
      this.service.getPriceModel(this.clientId).subscribe(
        (priceModels) => {
          this.priceModels = priceModels;
          this.grid.refresh();
        }
      )
    );
  }

  ngOnDestroy(): void {
    this._subscriptions?.unsubscribe();
  }

}
